import "./Order.scss";
import { Link } from "react-router-dom";
import { LocationIcon, PhoneIcon, EmailIcon } from "../../assets/global/Icons";
import OrderForm from "./OrderForm";
import ContactInfo from "./ContactInfo";

function Order() {
  return (
    <div className="wrapper">
      <h1>Order your next celebration dessert</h1>
      <div className="order-container">
        <div className="order-container__two-third">
          <p>
            Interested in placing an order or getting a quote? Fill out the form
            below and I will get in touch! Please allow at least 2 weeks notice
            to secure your spot, otherwise a rush order fee will apply.
            Exceptions may be given to established corporate clients.
          </p>
          <OrderForm />
        </div>
        <div className="order-container__one-third">
          <ContactInfo
            img={<LocationIcon className="contact__icon" />}
            title="Mountain View, CA"
            subtitle="Serving the SF Bay Area"
            link={null}
          />
          <ContactInfo
            img={<PhoneIcon className="contact__icon" />}
            title="Let's chat"
            subtitle="408-800-2092"
            link={null}
          />
          <ContactInfo
            img={<EmailIcon className="contact__icon" />}
            title="Other comments?"
            subtitle="connie@conniescakerie.com"
            link="mailto:connie@conniescakerie.com"
          />
          <section className="faqs-section">
            <h2>FAQs</h2>
            <ul className="faqs-section__list">
              <li>
                <Link to="/faqs#faq-payment">
                  What payment options do you accept? Do you require a deposit?
                </Link>
              </li>
              <li>
                <Link to="/faqs#faq-shelf-life">
                  What's the shelf life of your desserts?
                </Link>
              </li>
              <li>
                <Link to="/faqs#faq-samples">
                  Do you offer any cake samples?
                </Link>
              </li>
              <li>
                <Link to="/faqs#faq-shipping">Do you ship your products?</Link>
              </li>
              <li>
                <Link to="/faqs#faq-allergens">
                  Can you accommodate dietary restrictions and allergies?
                </Link>
              </li>
              <li>
                <Link to="/faqs#faq-cake-height">
                  How tall are your cakes? How many layers do they have?
                </Link>
              </li>
            </ul>
            <Link to="/faqs" className="view-all-faqs">
              View all frequently asked questions
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Order;
